/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a key to call the oneAI API with Bearer auth from outside the app." |
*
* @param {Profile_Security_User_Api_Key_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_empty_description = /** @type {((inputs?: Profile_Security_User_Api_Key_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle einen Schlüssel, um die oneAI-API per Bearer-Auth von außerhalb der App aufzurufen.")
	return /** @type {LocalizedString} */ ("Create a key to call the oneAI API with Bearer auth from outside the app.")
});